
export class AttendanceDto {
    Id?: number;
    year:number;
    month: number;
    day: number;
    empId: number;
    projectId: number;
    costCenterId: number;
    subContractorId:number;
    attenDate: string;
    attenStatus: string;
    attendanceSubmitted:boolean;
    otCapturedTime?: string;
    otHours?: number;
    otCreatedUser? : number;
    otApprovalStatus? :boolean;
    otApprovedUser? : number;
    attenCreatedUser?: Number;
    attenApprovalStatus? :boolean;
    attenApprovedUser? : Number;
    dailyPay? : string;
    createdAt? : Date | any;
    updatedAt?: Date | any;
    updatedUser? : number;
    isActive? : boolean;
    versionFlag? : number;
    empInfo ?: any;
    longitude?:any;
    latitude?:any;
}


export class MonthWiseAttendanceReport {
    year: number;
    month: number;
    projectId: number;
    empId: number;
    subContractorId: number;
  }
  export class ProjectsReport {
    year: number;
    month: number;
  }
  export class NotificationsReport {
    activityDate: Date;
  }
  
  export class EmployeesPayments {
    toDate: Date;
    projectId: number;
    subContractorId: number;
  }

  export class EmployeesPaymentsRequest {
    attendanceIds:number;
    projectIds:number;
    subContractorIds:number;
    paymentDate: Date;
    paidDate: Date;
  }

// export const AttendanceDtoDefault : AttendanceDto = {
//     Id: 1,
//     year:0,
//     month: 0,
//     day: 0,
//     date: '',
//     empId: 0,
//     attendanceStatus: 'A',
//     otHours: 0,
//     costCenterId: 0,
//     status: true,
//     createdAt : new Date() ,
//     createdUser : 0,
//     updatedAt : new Date() ,
//     updatedUser : 0,
//     versionFlag : 1

// };

